// src/components/video.js
import {instance} from '../axios'// 自定义axios

export const uploadUrl = process.env.VUE_APP_API_BASE_URL + '/common/upload-file/'

const videoApi = {
  // 上传图片
  uploadImg(files) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    return instance
      .post(uploadUrl, files, options)
  },

  // 你可以根据需要添加更多方法，比如上传视频
  // uploadVideo(file) {
  //   const formData = new FormData()
  //   formData.append('video', file)
  //   return axios({
  //     url: '/upload/uploadVideo',
  //     method: 'POST',
  //     data: formData,
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     }
  //   })
  // }
}

export default videoApi
